import { BaseOneServiceI18n } from '@soluto-private/mx-i18n';
import React, { FunctionComponent, ProviderProps, ReactNode } from 'react';
import { I18nContext } from './i18nClient';

export type I18nProviderProps = ProviderProps<
  BaseOneServiceI18n | undefined
> & {
  fallbackComponent?: ReactNode;
};

export const I18nProvider: FunctionComponent<I18nProviderProps> = ({
  children,
  fallbackComponent = null,
  ...props
}) => (
  <I18nContext.Provider {...props}>
    <I18nContext.Consumer>
      {(i18n) => (i18n ? children : fallbackComponent)}
    </I18nContext.Consumer>
  </I18nContext.Provider>
);
